import { GlobalNavigationItem, GlobalNavigationBarMode } from "./navigationItem";
import { SpaceKind } from "client/Api/Workspace/workspace";
import { GlobalNavigationItemModel, SpaceUserInfo } from "client/Api/TitleBar/GlobalNavigation/globalNavigation";
import { ISpaceNavigationHandler } from "client/Features/Layout/GlobalNavigationSidebar/SubNavigationContent/useSpaceNavigationHandler";

interface SpaceNavigationItemOptions {
	id: number;
	name: string;
	spaceId: number;
	spaceKind: SpaceKind;
	userInfo: SpaceUserInfo;
	model: GlobalNavigationItemModel;
	spaceNavigationHandler: ISpaceNavigationHandler;
}

export class SpaceNavigationItem implements GlobalNavigationItem {
	private readonly _spaceNavigationHandler: ISpaceNavigationHandler;

	public readonly id: number;
	public readonly name: string;
	public readonly model: GlobalNavigationItemModel;
	public readonly spaceId: number;
	public readonly spaceKind: SpaceKind;
	public readonly userInfo: SpaceUserInfo;

	constructor(options: SpaceNavigationItemOptions) {
		this.id = options.id;
		this.name = options.name;
		this.model = options.model;
		this.spaceId = options.spaceId;
		this.spaceKind = options.spaceKind;
		this.userInfo = options.userInfo;
		this._spaceNavigationHandler = options.spaceNavigationHandler;
	}

	public activate(_mode: GlobalNavigationBarMode) {
		this._spaceNavigationHandler
			.activate(
				this.spaceId
			);
	}

	public canActivate(mode: GlobalNavigationBarMode): boolean {
		return this._spaceNavigationHandler
			.canActivate(
				this.spaceId,
				mode
			);
	}

	public async canDeactivate(mode: GlobalNavigationBarMode): Promise<boolean> {
		return this._spaceNavigationHandler
			.onPreventDeactivation(mode);
	}
}
